var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ict-container"},[_c('div',{staticClass:"ict-container-banner"},[_c('Header'),_c('div',{staticClass:"container-banner-text1"},[_vm._v("消防培训")]),_c('div',{staticClass:"container-banner-text2"},[_vm._v("模块化设计自由定制")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }